import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

const pulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Loading = ({ message = 'Carregando...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#EBF1F3',
        gap: 3
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Círculo externo pulsante */}
        <Box
          sx={{
            position: 'absolute',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: 'rgba(1, 47, 71, 0.1)',
            animation: `${pulse} 1.5s ease-in-out infinite`
          }}
        />
        
        {/* Spinner principal */}
        <CircularProgress
          size={50}
          thickness={4}
          sx={{
            color: '#012F47',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            }
          }}
        />
      </Box>

      {/* Mensagem de loading */}
      <Typography
        variant="body1"
        sx={{
          color: '#012F47',
          fontWeight: 500,
          fontSize: '16px',
          animation: `${pulse} 1.5s ease-in-out infinite`,
          textAlign: 'center',
          maxWidth: '80%'
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default Loading;
